const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import YXXTableView from "./yxx_table_view";
import YXXTableModel from "./yxx_table_model";
import * as ProtoGame from "../../net/proto/yxx_proto_game"
import * as ProtoRoom from "../../net/proto/yxx_proto_room"
import NetMsgData from "../../net/yxx_net_msg_data_game"
import GameServer from "../../../hall/server/gameserver/game_server";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import EventManager from "../../../../manager/event_manager";
import SceneManager from '../../../../manager/scene_manager';
import DialogTips from "../../../public/module/dialog_tips/dialog_tips"
import LanguageManager from "../../../../manager/language_manager";
import { RoadMap_yxx } from "../roadmap_yxx/roadmap_yxx";
import CaiChi from "../caichi/caichi"
import PlayerListModule from "../../../longhudou/module/playerlist/playerlist_module"
import { CountUp } from "../../../../lib/countUp";
import Utility from "../../../../utility/utility";
import Util from "../../../longhudou/module/util";
import AppData from "../../../public/const/app_data";
import { RoadMap_tb } from "../roadmap_tb/roadmap_tb";
import MorePanel from "../../../table/module/game_morepanel/game_morepanel"
import { CaiChiTips } from "../caichi_tips/caichi_tips";
import UserDataManager from "../../../../manager/user_manager";
import BankerListModule from "../../../table/module/bankerlist/bankerlist_module";
import YXXTableViewBase from "./yxx_table_view_base";
import YXXuModelBase from "./yxx_table_model_base";
import TableBaseModule from "../../../table/module/table_base/table_base_module";
import { joinUtil } from "../../../public/join_util";

@ccclass
export default class YXXTableModuleBase<T extends YXXTableViewBase, U extends YXXuModelBase> extends TableBaseModule<T, U>  {

    currentGold = 0
    localBetIndex = 0 //本地下注的Index
    betIndex = 0 //服务器返回的
    currentBetType = null
    initBetData = null //押注数据
    lastRoundBetData = null //上局
    currentResult = null //当前结果
    twentyTimesResult = null //最近20场记录
    isCanBet = false  //是否可下注
    roomStatus = null //房间状态
    m_lastRefreshTime = 0
    m_clockScheduleId = 0 //时钟ID
    superWinner = null //神算子
    myRoleData = null //自己的数据
    isFristBetAim = true //是否播放开始下注动画
    isAutoBet = false //是否勾选自动下注
    autoBetOver = false //是否已经自动下注完毕
    myGold = 0
    retainCount = 0 //需要保留的筹码
    roomTypeByName = ["T", "C", "Z", "G"]
    JackpotData = 0 // 彩池余额
    lastJackpotData = 0 //// 上次彩池余额
    JackpotDataAdd = 0 //新增的彩池 用来飘筹码
    isPlayCaiChiAnim = false
    isNeedCaiChi = false
    betNameList = null
    BtnStatus =  {
        None:0, //可用状态
        Gray:1, //置灰不可用
        NoneGray: 2, //透明不可用
    }
    curBtnStatus = this.BtnStatus.Gray //当前续压按钮状态
    rule = null
    bankers = [] //等待上庄玩家
    bankBtnType = 1//上庄状态
    currentRanker: ProtoGame.YXXGame.IBanker = null //当前庄家
    shangzhuang = false //上下庄标识
    


    onShow(intentData) {
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        super.onShow(intentData);        
        this.view.isTb = AppData.gameSimpleName == "TB"
        this.registNetMsg()
        this.bindEvent()
        this.view.tableSound.playBgm()
        this.rule = ModelData.instance.roomInfo.PlayRuleData
        this.retainCount = Number(this.rule.game_Retain || 0)
        this.view.initBetBtn(this.rule.game_BetArr, false)
        this.view.initBetArea(this.betNameList)
        this.currentBetType = this.rule.game_BetArr[0]
        //删除isMangoTable的判断  modif by dred 
        this.view.myGoldSpr.spriteFrame = this.view.goldTypeSpr[1]
        if (this.lastRoundBetData == null || this.lastRoundBetData.length == 0){
            this.curBtnStatus = this.BtnStatus.Gray
            //this.setAutoBtnStatus()
        }
        else{
            this.curBtnStatus = this.BtnStatus.None
            
        }
        this.view.clockNode.active = false
        this.setAutoBtnStatus(this.curBtnStatus)
    }

    protected onButtonClickName(name: string) {

        switch (name) {
            case "MoreBtn":
                ModuleManager.instance.showModule(MorePanel)
                break;
            case "CaiChi":
                this.isNeedCaiChi = true
                this.model.request_jackpot_result()
                break
            case "AutoBetBtn":
                this.onAutoBetClick(true, false)
                break
            case "IsAutoBetBtn":
                this.updateIsAutoBet()
                break
            case "XinBtn":
                this.view.giveReward()
                break
            case "Player8":
                this.model.request_online_players()
                break
            case "TestButton":
                this.model.disconnect()
                break
            case "GoBankerBtn":
                this.openBankerList()
                break;
            case "CloseGoBankerBtn":
                if (this.currentRanker != null && (this.currentRanker.id == this.myRoleData.id)) {
                    //下庄提示 TODO
                    this.shangzhuang = true
                    this.model.request_hold_banker(2)
                }
                break 
            case "Head":
                ModuleManager.instance.showEmojiModule(this.myRoleData.id,this.moduleName)
                break
            case "Player":
                //点击庄家
                this.currentRanker && ModuleManager.instance.showEmojiModule(Number(this.currentRanker.id), this.moduleName)
                break
            default:
                break;
        }
    }

    protected onButtonClick(obj: cc.Node) {
        if (obj.parent == this.view.betObj || obj.parent == this.view.betOther) {
            this.view.showChooseJetton(obj)
            this.currentBetType = this.view.jettonItemBtns[obj.name].Count
        }
        else if (obj.parent.name == "BetArea") {
            let area = Number(obj.name)
           this.isBet(area)
            //押注后取消勾选自动押注
            if (this.isAutoBet){
                this.updateIsAutoBet()
            }
            if (this.view.autoBetBtn.enabled == true){
                this.setAutoBtnStatus(this.BtnStatus.Gray)
            }
        }
        else if (obj.parent.name == "Players"){
            this.clickPlayIcon(obj)
        }
        else {

        }
    }

    clickPlayIcon(posNode)
    {
        for (const playerItem of this.view.playerItems) {
            if (playerItem.Obj == posNode && playerItem.Id != null){
                ModuleManager.instance.showEmojiModule(playerItem.Id,this.moduleName)
                return
            }
        }
        
    }

    getSeatNodeById(id){
        if (id == this.myRoleData.id){
            return this.view.playerItems[this.view.selfPosIndex].Icon.node
        }
        if (this.currentRanker != null && id == this.currentRanker.id){
            return this.view.bankerHead.node
        }
        for (const playerItem of this.view.playerItems) {
            if ( playerItem.Id == id){
                return playerItem.Icon.node
            }
        }
        return null
    }

    registNetMsg() {
        let self = this

        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.RoomInfo>(NetMsgData.RoomInfo, function (protoData) {
            self.changeRoomInfo(protoData)
        })
        //押注成功
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BetRsp>(NetMsgData.BetReq, function (protoData: ProtoGame.YXXGame.IBetRsp) {
            self.currentGold = self.currentGold + self.currentBetType
            self.scheduleOnce(()=>{
                self.betIndex += 1
                //押注失败
                if (protoData.errorCode != 0) {
                    //押注失败 返回一个筹码
                    ModuleManager.instance.toastKey("server_error_"+ protoData.errorCode)
                    if (self.view.betDataByIndex[self.betIndex] != null){
                        self.myGold += self.view.betDataByIndex[self.betIndex].type == null ? 0 : self.view.betDataByIndex[self.betIndex].type
                        self.view.playBetDefeated(self.betIndex, self.myGold)
                        self.aotuChooseBetBtn()
                        self.view.updateJettonMask(self.myGold - self.retainCount, false)
                    }


                }
            }, 0.2) //往后延迟一点点 让押筹码 和回来得流程完整

        })

        //刷新押注数据
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BetBroadCast>(NetMsgData.BetData, function (protoData: ProtoGame.YXXGame.IBetBroadCast) {
            if (self.initBetData == null) {
                self.view.refreshBetArea(protoData.totalData, protoData.selfTotalBetData.data)
                self.view.playOtherBetAmin(protoData.totalData, false, false)
                
            }
            else {
                self.view.refreshBetArea(protoData.totalData, protoData.selfTotalBetData.data, !self.isCanBet)
                self.disPoseNewBetData(protoData)
            }
            self.initBetData = protoData

        })
        //押注结果
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BetResult>(NetMsgData.BetResult, function (protoData) {
            self.currentResult = protoData
        })

        //刷新最近20场记录
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BetResultHistory>(NetMsgData.TwentyTimesResult, function (protoData: ProtoGame.YXXGame.BetResultHistory) {
            self.on_refresh_result_history(protoData)           
        })

        //获取历史记录
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BetResultDetailRsp>(NetMsgData.GetHistoryResult, function (protoData) {
            //TODO
        })

        //获取在线玩家
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.OnlinePlayersRsp>(NetMsgData.GetOnlinePlayers, function (protoData) {
            ModuleManager.instance.showModule(PlayerListModule, protoData.players)
        })


        //收到离开房间
        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.LeaveRsp>(NetMsgData.LeaveRoom, function (protoData: ProtoRoom.YXXRoom.ILeaveRsp) {
            if (protoData.errCode != -226) {
                self.leaveRoom()
                SceneManager.gotoHallOrClubHall("TabelExit")
                if (protoData.errNo != "0"){
                    ModuleManager.instance.showModule(DialogTips, { Content: LanguageManager.t("server_error_" + protoData.errCode) ,titleError : true })
                }
            }
            else{
                ModuleManager.instance.toastKey("server_error_" + protoData.errCode)
            }
        })

        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.NotifyMsg>(NetMsgData.NotifyMsg, function (protoData: ProtoRoom.YXXRoom.INotifyMsg) {
            let str = ""
            if (protoData.code == 1) {
                str = LanguageManager.t("lhd_tipsBetExit")
            }
            ModuleManager.instance.showModule(DialogTips, { Content: str })
        })

        //奖池新增
        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.JackpotAdd>(NetMsgData.JackpotAdd, function (protoData: ProtoRoom.YXXRoom.IJackpotAdd) {
            self.JackpotDataAdd = protoData.add
        })


        //收到彩池数据
        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.JackpotResult>(NetMsgData.JackpotResult, function (protoData) {

            if(self.isNeedCaiChi){
                let data = {
                    caichiData : protoData,
                    jackpotData : self.JackpotData,
                    isTb : self.view.isTb,
                    isFreeGame: self.view.isFreeGame
                }
                ModuleManager.instance.showModule(CaiChi, data)
                self.isNeedCaiChi = false
            }
            else{
                for (const playerData of protoData.players) {
                    let userData = JSON.parse(playerData.userData)
                    if (userData.user_id == self.myRoleData.id){
                        ModuleManager.instance.showModule(CaiChiTips)
                        return
                    }
                }
            }
        })

        //收到彩池余额改变通知
        self.model.subscibeMsgEvent<ProtoRoom.YXXRoom.JackpotChange>(NetMsgData.JackpotChange, function (protoData: ProtoRoom.YXXRoom.IJackpotChange) {
            self.JackpotData = protoData.num
            if (!self.isPlayCaiChiAnim || self.JackpotData < self.lastJackpotData){
                self.changeCaiChi()
            }
        })

        //上下庄
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BankerRsp>(NetMsgData.BankerReq, function (protoData) {
            if (self.shangzhuang) {
                self.shangzhuang = false
                ModuleManager.instance.toastKey("banker_close")
            }
        })

        //更新上庄请求列表
        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BankerList>(NetMsgData.WaitBankerList, function (protoData: ProtoGame.YXXGame.IBankerList) {
            self.bankers = protoData.bankers
            self.bankBtnType = 1
            for (const value of self.bankers) {
                if (value.round == 0 && (value.id == self.myRoleData.id)) {
                    self.bankBtnType = 2
                    break
                }
            }
            if (self.currentRanker == null || self.currentRanker.id != self.myRoleData.id){
                self.view.updateBankerBtn(true, false)
            }
            
            EventManager.instance.dispatch("event_update_banker", { Data: self.bankers, BtnType: self.bankBtnType, Rule:self.rule})
        })

        self.model.subscibeMsgEvent<ProtoGame.YXXGame.BankerInfo>(NetMsgData.BankerInfo, function(protoData:ProtoGame.YXXGame.IBankerInfo){
            self.onMsgBankerInfo(protoData)            
            
        })
    }

    changeCaiChi(){
        let self = this
        EventManager.instance.dispatch("event_update_caichinum", self.JackpotData)
        if(!self.isPlayCaiChiAnim || self.JackpotData < self.lastJackpotData ){
            self.view.caichiNumLab.string = Util.toThousands(  self.JackpotData.toString().padStart(10,"0") ) 
            self.lastJackpotData = self.JackpotData 
        }else{
            if(self.lastJackpotData != self.JackpotData){
                let caichiCountUp = new CountUp(null, self.JackpotData,{
                    startVal: self.lastJackpotData,
                    decimalPlaces: 0,
                    duration: 2,
                    useEasing: true,
                    useGrouping: false,
                    smartEasingThreshold: 999,
                    smartEasingAmount: 333,
                    separator: ',',
                    decimal: '.',
                    prefix: '',
                    suffix: ''
                })
                if(!caichiCountUp.error){
                    caichiCountUp.start((n)=>{
                        self.view.caichiNumLab.string = Util.toThousands( n.padStart(10,"0") )  
                    })
                }

                self.lastJackpotData = self.JackpotData
            }
        }
        self.isPlayCaiChiAnim = true
    }

    private bindEvent() {
        let self = this
        this.eventBind("event_req_banker", this.requestHoldBanker);
        this.eventBind("event_exit_game", function(){
            self.model.request_leave_room()
        });
    }

    //房间信息得改变
    //     STARTING = 0,      -- 开始
    //   SHUFFLING = 1,    -- 洗牌
    //   READY = 2,      -- 准备
    //   DEAL = 3,      -- 发牌
    //   BETTING = 4,      -- 下注
    //   TURN = 5,      -- 开牌
    //   SETTLE = 6,      -- 派奖
    changeRoomInfo(roomData: ProtoRoom.YXXRoom.RoomInfo) {
        let self = this
        switch (roomData.state) {
            case 3: // 准备
                this.setLastRoundBetData() 
                this.isFristBetAim = true
                this.localBetIndex = 0
                this.betIndex = 0
                this.initBetData = null
                this.autoBetOver = false
                this.view.cleanTable()
                this.view.playReadyAmin(this.roomStatus != null)
                self.eventDispatch('Game_Table_Start');
                break
            case 5: //下注
                //this.isCanBet = true
                if (this.isFristBetAim) {
                    if (self.roomStatus != null){
                        this.view.showBetTips(true)
                    }
                    let tempTime = this.roomStatus == null ? 0 : 2
                    self.scheduleOnce(function () {
                        self.isCanBet = true
                        self.setAutoBtnStatus(self.curBtnStatus)
                        self.view.updateJettonMask(self.myGold - self.retainCount, false)
                        self.showBetTime(roomData.betTimeout - tempTime, true)
                    }, tempTime)
                    self.isFristBetAim = false
                }
                self.updatePlayerInfo(roomData)
                break
            case 6: //开牌
                this.setAutoBtnStatus( (this.curBtnStatus == this.BtnStatus.None) ? this.BtnStatus.NoneGray : this.curBtnStatus)
                self.isCanBet = false
                self.updatePlayerInfo(roomData)
                if (this.roomStatus != null) {
                    this.view.showResulet(this.currentResult, function () {
                        EventManager.instance.dispatch("event_update_betresulthistory", self.twentyTimesResult)
                    })
                }
                break
            case 7: //派奖
                self.updatePlayerInfo(roomData)
                if (self.initBetData != null){
                    self.view.playResultAmin(this.currentResult, self.initBetData.totalData, self.JackpotDataAdd) //
                    self.JackpotDataAdd = 0
                }
                self.scheduleOnce(function () {
                    self.changeCaiChi()
                }, 1)
                break
            default:
                break;
        }
        if (this.roomStatus == null) {
            if(roomData.state != 3){
                self.eventDispatch('Game_Table_Start');
            }
            self.updatePlayerInfo(roomData)
            if (roomData.state >= 6) {
                this.view.showResulet(this.currentResult, function () {
                  
                }, false)
            }
        }
        this.roomStatus = roomData.state
    }


    isBet(area: number, isAuto:boolean = false): boolean {
        if (this.currentRanker != null && this.currentRanker.id == this.myRoleData.id){
            return
        }

        if (this.roomStatus != 5 || !this.isCanBet) {
           // ModuleManager.instance.toast(LanguageManager.t("server_error_-205"))
            return false
        }
        if (this.currentBetType == null) {
            ModuleManager.instance.toastKey("lhd_qxzyz");
            joinUtil.showRechargeInMultiple(this);
            return true
        }

        if (this.roomStatus == 7) {
            ModuleManager.instance.toastKey("lhd_zzkjshyz")
            return true
        }

        if ((this.myGold - this.currentBetType - this.retainCount) < 0){
            ModuleManager.instance.toastKey("server_error_-41")
            return
        }



        
        this.localBetIndex += 1
        this.myGold -= this.currentBetType
        this.view.playBetSelfAmin(this.currentBetType, area, this.localBetIndex, this.myGold)
        this.model.request_bet(area, this.currentBetType)
        //续压模块
        if (!isAuto){
            for (const key in this.lastRoundBetData) {
                if (Number(key) == area &&  this.lastRoundBetData.hasOwnProperty(key) ) {
                    const areaDatas = this.lastRoundBetData[key];
                    for (let index = 0; index < areaDatas.length; index++) {
                        if (areaDatas[index] == this.currentBetType){
                            areaDatas.splice(index,1)
                            break
                        }
                        
                    }
                }
            }
        }
        this.aotuChooseBetBtn()
        this.view.updateJettonMask(this.myGold - this.retainCount, false)
        return true
    }

    //更新玩家信息 一般 结算的时候 或者刚进入
    updatePlayerInfo(roomInfo: ProtoRoom.YXXRoom.RoomInfo) {
        if (roomInfo.players == null) { return }
        let playerDatas = roomInfo.players
        this.view.isShowPlayerIndex = []
        for (const data of playerDatas) {
            let isUpdate = true //本次是否更新数据
            let isMySelf = ModelData.instance.roleData.id == Number(data.id)
            if (isMySelf){
                this.myRoleData = data
                this.currentGold = 0
                isUpdate = false
                if (this.roomStatus == null || roomInfo.state == 7) {
                    this.myGold = Number(data.balance)
                    isUpdate = true
                    this.aotuChooseBetBtn()
                    this.view.updateJettonMask(this.myGold - this.retainCount, roomInfo.state != 5)
                    UserDataManager.balanceChangeMessage(this.myGold)
                }

            }
            UserDataManager.setUserGameTableCurrency(Number(data.id), Number(data.balance))
            this.view.updatePlayerInfo(data, isUpdate, isMySelf)
        }

        if (playerDatas.length < this.view.selfPosIndex) {
            this.view.hidePlayerItem()
        }

    }

    //自动选择下注按钮 遇到更新上一次选择的筹码本次不够时候 还要更新到可用的最大的
    aotuChooseBetBtn() {
        if (this.myRoleData == null) { return }
        let canBetCount = this.myGold -  this.retainCount
        if (this.currentBetType != null){
            if (this.currentBetType > canBetCount){
                
                let objItemData = null
                for (const key in this.view.jettonItemBtns) {
                    if (this.view.jettonItemBtns.hasOwnProperty(key)) {
                        const element = this.view.jettonItemBtns[key];
                        if (element.Count <= canBetCount){
                            objItemData = element
                        }
                    }
                }
                if (objItemData != null){ 
                    this.onButtonClick(objItemData.BtnObj.node)
                }
                else{
                    this.currentBetType = null
                    this.view.showChooseJetton(null)
                }
            }
        }
        else{
            const element = this.view.jettonItemBtns["1"];
            if (element.Count <= canBetCount){
                this.onButtonClick(element.BtnObj.node)
            }
        }
    }


    //显示剩余下注时间
    showBetTime(time: number, isBet: boolean = false) {
        let self = this
        if (!isBet || time <= 2){
            this.view.clockNode.active = false
            return
        }

        if (time > 8){
            self.scheduleOnce(function () {
                self.view.playDaoJiShi()
            }, time - 8)
        }

        self.scheduleOnce(function () {
            self.view.clockNode.active = false
            self.view.showBetTips(false) 
            self.isCanBet = false //最后一秒同步下本地数据 停止下注
            this.view.updateJettonMask(this.myGold - this.retainCount, true)
            if (self.initBetData != null){
                self.view.refreshBetArea(self.initBetData.totalData, self.initBetData.selfTotalBetData.data, true)
            }
        }, time - 2.5)
        
        this.view.clockNode.active = true
        if (this.m_clockScheduleId > 0) {
            this.cancelSchedule(this.m_clockScheduleId)
            this.m_clockScheduleId = 0
        }
        
        var refreshClockLable = function () {
            if (time < 0) { return }
            self.view.clockLab.string = (time - 3).toString()
            self.m_clockScheduleId = self.doScheduleOnce(function () {
                self.m_clockScheduleId = 0
                time--
                refreshClockLable()
            }, 1)
        }
        refreshClockLable()
    }


    //处理新的押注数据
    disPoseNewBetData(betData: ProtoGame.YXXGame.IBetBroadCast) {
        if (betData.newData == null || betData.newData.length <= 0) { return }
        if (betData.playersBetData == null) { return }
        let otherBetData = betData.newData
        let isPlaying = false
        for (const value of betData.playersBetData) {
            if (value.data != null) {
                isPlaying = value.id != this.myRoleData.id
                this.view.playBetAmin(value, value.id == this.myRoleData.id, otherBetData)
            }
        }

        if (isPlaying) {
            this.view.tableSound.playBet(false)
        }

        this.view.playOtherBetAmin(otherBetData, true, isPlaying)
    }

    //整理上一局押注数据
    setLastRoundBetData(){
        if (this.view.betDataByIndex.length == 0) { return }
        this.lastRoundBetData = null
        for (const iterator of this.view.betDataByIndex) {
            if (iterator != null && iterator.count > 0){
                if (this.lastRoundBetData == null){
                    this.lastRoundBetData = []
                }
                if (this.lastRoundBetData[iterator.area] == null){
                    this.lastRoundBetData[iterator.area] = []
                }
                this.lastRoundBetData[iterator.area].push(iterator.type)
            }
        }
        //此处计算 是查看续压得金额是否还足够
        let count = 0
        for (const key in this.lastRoundBetData) {
            if (this.lastRoundBetData.hasOwnProperty(key)) {
                const areaDatas = this.lastRoundBetData[key];
                for (const iterator of areaDatas) {
                    count += iterator
                   
                }
            }
        }
        let isCanAutoBet = count <= this.myRoleData.balance
        if (this.lastRoundBetData == null || !isCanAutoBet){
            this.curBtnStatus = this.BtnStatus.Gray
            if (this.isAutoBet){
                ModuleManager.instance.toastKey("lhd_tipsNoAutoBet")
                this.updateIsAutoBet()
            }
        }
        else{
            this.curBtnStatus = this.BtnStatus.None            
        }
        this.view.betDataByIndex = []
    }

    //点击自动下注
    onAutoBetClick(isBet, isAuto){
        if (!isBet || this.lastRoundBetData == null){ return }
        let count = 0
        let oldType = this.currentBetType
        //重新计算一遍是为了 在押注了别的后 再点续压
        for (const key in this.lastRoundBetData) {
            if (this.lastRoundBetData.hasOwnProperty(key)) {
                const areaDatas = this.lastRoundBetData[key];
                for (const iterator of areaDatas) {
                    count += iterator
                }
            }
        }
        if (count <= this.myRoleData.balance){
            for (const key in this.lastRoundBetData) {
                if (this.lastRoundBetData.hasOwnProperty(key)) {
                    const areaDatas = this.lastRoundBetData[key];
                    for (const iterator of areaDatas) {
                        if (iterator != this.currentBetType){
                            this.currentBetType = iterator
                        }
                        this.isBet(Number(key), true)
                    }
                }
            }
        }
        else{
            if (isAuto){
                ModuleManager.instance.toastKey("lhd_tipsNoAutoBet")
            }
        }
        this.onButtonClick(this.view.btnNodeByBetType[oldType])
        this.setAutoBtnStatus(this.BtnStatus.NoneGray)
    }

    //勾选自动下注
    updateIsAutoBet(){
        this.isAutoBet = !this.isAutoBet
        this.view.autoGou.active = this.isAutoBet
        if (this.isAutoBet){
            ModuleManager.instance.toastKey("lhd_tipsAutoBet")
        }
    }

    autoBetEvent(isBet){
        if (!this.isAutoBet){
             return
        }
        this.onAutoBetClick(isBet ,true) 
        this.autoBetOver = true
    }

    
    //设置续压按钮的状态
    setAutoBtnStatus(statusType){
        switch(statusType){
            case this.BtnStatus.None:
                this.view.autoBetBtn.enabled = true
                Utility.setBtnGray(this.view.autoBetBtn, false)
                Utility.resetGray(this.view.autoBetBtnSpr)
                this.view.autoBetBtn.node.opacity = 255
                break;
            case this.BtnStatus.Gray:
                this.view.autoBetBtn.node.opacity = 255
                Utility.setGray(this.view.autoBetBtnSpr)
                Utility.setBtnGray(this.view.autoBetBtn, true)
                break;
            case this.BtnStatus.NoneGray:
                this.view.autoBetBtn.enabled = false
                this.view.autoBetBtn.node.opacity = 80
                break;
            default:
                break;
        }
    }

    leaveRoom() {
        this.view.tableSound.stopBgm()
        if(AppData.gameSimpleName == "YXX"){
            ModuleManager.instance.destroyModule("RoadMap_yxx")
        }else if (AppData.gameSimpleName == "TB"){
            ModuleManager.instance.destroyModule("RoadMap_tb")
        }
    }

    //打开上庄列表
    openBankerList() {
        ModuleManager.instance.showModule(BankerListModule, { Data: this.bankers, BtnType: this.bankBtnType, Rule: this.rule})
    }

    requestHoldBanker() {
        if (this.bankBtnType == 1 && this.myGold < this.rule.pub_BeDealerLimit){
            ModuleManager.instance.toast(LanguageManager.t("banker_tips").format(this.rule.pub_BeDealerLimit))
            return
        }
        this.model.request_hold_banker(this.bankBtnType)
    }

    on_refresh_result_history(protoData: ProtoGame.YXXGame.BetResultHistory){
        let self = this
        if (self.twentyTimesResult == null){
            EventManager.instance.dispatch("event_update_betresulthistory", protoData.result)
        }
        self.twentyTimesResult = protoData.result
    }

    onMsgBankerInfo(protoData:ProtoGame.YXXGame.IBankerInfo){
        let self = this
        self.currentRanker = protoData.banker
        let betNode = this.view.isFreeGame ? this.view.betOther: this.view.betObj
        if (protoData.isPlayer){
            self.view.updateBanker(protoData.banker.id, protoData)
            let isWaitBanker = true
            let myIsBanker = self.currentRanker.id == self.myRoleData.id
            self.view.betBtnNode.active = !myIsBanker
            betNode.active = !myIsBanker
            if (myIsBanker && protoData.banker.round >= self.rule.pub_BeDealerMin){
                isWaitBanker = false
            }
            self.view.updateBankerBtn(!myIsBanker, !isWaitBanker)
        }
        else{
            self.view.banker.active = false
            self.view.sysBanker.active = true
            self.view.sysYiZi.active = true
            self.view.lastBankerId = null
            self.view.betBtnNode.active = true
            betNode.active = true
            self.view.updateBankerBtn(true, false)
        }
    }

    protected onUserCoinBalanceNotify(data: {playerId: number, coinBalance: number}){
        super.onUserCoinBalanceNotify(data)
        this.view.refreshPlayerCoinBalance(data.playerId, data.coinBalance)
    }
}